import React, {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import PublicApiTokenList from '../integrations/components/PublicApiTokenList'

const developersApiBreadcrumbs: Array<PageLink> = [
  {
    title: 'Desenvolvedores',
    path: '/admin/api',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DevelopersApiPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={developersApiBreadcrumbs}>API</PageTitle>

      <div className='row g-5 g-xl-8'>
        <div className='col-12'>
          <PublicApiTokenList />
        </div>
      </div>
    </>
  )
}

export default DevelopersApiPage
